import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, LI, UL } from "../../../../AbstractElements";
import { FileFilter } from "../../../../Constants/Constants";
import { SideButtons } from "../../../../Data/Applications/FileManager/FileManager";
import StoragePlan from "./StoragePlan";
import PricingPlans from "./PricingPlans";

const FileSideBar = () => {
  const [IsOpen, setIsOpen] = useState(false);

  return (
    <Col xl="3" className="box-col-30">
      <div className="md-sidebar">
        <Btn color="primary" className="md-sidebar-toggle" onClick={() => setIsOpen(!IsOpen)}>{FileFilter}</Btn>
        <div className={`md-sidebar-aside custom-scrollbar ${IsOpen ? "open" : ""}`}>
          <div className="file-sidebar">
            <Card>
              <CardBody>
                <UL className="simple-list ">
                  {SideButtons.map((item, i) => (
                    <LI key={i}>
                      <Btn className={item.className} color={item.Name}>
                        {item.icon}
                        {item.title}
                      </Btn>
                    </LI>
                  ))}
                </UL>
                <hr />
                <StoragePlan />
                <hr />
                <PricingPlans />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default FileSideBar;
